export enum NotificationEventType {
  NOTIFICATION_DATES_AUTO_SETUP = 'NOTIFICATION_DATES_AUTO_SETUP',
  PLANNED_LEAVES_NOTIFICATION = 'PLANNED_LEAVES_NOTIFICATION',
  SETUP_REMINDER_NOTIFICATION = 'SETUP_REMINDER_NOTIFICATION',
  TIME_LOGGING_DEADLINE_INIT = 'TIME_LOGGING_DEADLINE_INIT',
  TIME_LOGGING_DEADLINE_UPDATE = 'TIME_LOGGING_DEADLINE_UPDATE',
  PLANNED_LEAVES_NOTIFICATION_DATE_INIT = 'PLANNED_LEAVES_NOTIFICATION_DATE_INIT',
  PLANNED_LEAVES_NOTIFICATION_DATE_UPDATE = 'PLANNED_LEAVES_NOTIFICATION_DATE_UPDATE',
  PLANNED_LEAVES_BODY_UPDATE = 'PLANNED_LEAVES_BODY_UPDATE',
  WORK_REPORT_NOTIFICATION = 'WORK_REPORT_NOTIFICATION',
  WORK_REPORT_NOTIFICATION_DATE_INIT = 'WORK_REPORT_NOTIFICATION_DATE_INIT',
  WORK_REPORT_NOTIFICATION_DATE_UPDATE = 'WORK_REPORT_NOTIFICATION_DATE_UPDATE',
  MISSING_TIME_LOG_FIRST_NOTIFICATION_DATE_INIT = 'MISSING_TIME_LOG_FIRST_NOTIFICATION_DATE_INIT',
  MISSING_TIME_LOG_FIRST_NOTIFICATION_DATE_UPDATE = 'MISSING_TIME_LOG_FIRST_NOTIFICATION_DATE_UPDATE',
  MISSING_TIME_LOG_SECOND_NOTIFICATION_DATE_INIT = 'MISSING_TIME_LOG_SECOND_NOTIFICATION_DATE_INIT',
  MISSING_TIME_LOG_SECOND_NOTIFICATION_DATE_UPDATE = 'MISSING_TIME_LOG_SECOND_NOTIFICATION_DATE_UPDATE',
  MISSING_TIME_LOG_NOTIFICATION = 'MISSING_TIME_LOG_NOTIFICATION',
  BENEFITS_NOTIFICATION = 'BENEFITS_NOTIFICATION',
  BENEFITS_NOTIFICATION_DATE_UPDATE = 'BENEFITS_NOTIFICATION_DATE_UPDATE',
  BENEFITS_DEADLINE_UPDATE = 'BENEFITS_DEADLINE_UPDATE',
  TEAMS_RATES_NOTIFICATION = 'TEAMS_RATES_NOTIFICATION',
  TEAMS_RATES_NOTIFICATION_DATE_UPDATE = 'TEAMS_RATES_NOTIFICATION_DATE_UPDATE',
  TEAMS_RATES_DEADLINE_UPDATE = 'TEAMS_RATES_DEADLINE_UPDATE',
  MONTHLY_INVOICES_NOTIFICATION = 'MONTHLY_INVOICES_NOTIFICATION',
  MONTHLY_INVOICES_NOTIFICATION_DATE_UPDATE = 'MONTHLY_INVOICES_NOTIFICATION_DATE_UPDATE',
  MONTHLY_INVOICES_DEADLINE_UPDATE = 'MONTHLY_INVOICES_DEADLINE_UPDATE',
  MONTHLY_INVOICES_BODY_UPDATE = 'MONTHLY_INVOICES_BODY_UPDATE',
  BANK_HOLIDAYS_REVIEW_REMINDER = 'BANK_HOLIDAYS_REVIEW_REMINDER',
}
